import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import 'moment/locale/de';

moment.locale('de');

function CountdownUnit({ value, label }) {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Box
        sx={{
          bgcolor: '#111',
          color: '#fff',
          px: { xs: 1, md: 1.5 },
          py: { xs: 0.5, md: 0.75 },
          minWidth: { xs: 48, md: 60 },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '1.5rem', md: '2rem' },
            fontWeight: 900,
            lineHeight: 1,
            fontVariantNumeric: 'tabular-nums',
            letterSpacing: '-0.5px',
          }}
        >
          {String(value).padStart(2, '0')}
        </Typography>
      </Box>

      <Box sx={{ bgcolor: '#111', opacity: 0.75, mt: '2px' }}>
        <Typography
          sx={{
            fontSize: '0.6rem',
            fontWeight: 800,
            letterSpacing: 1.5,
            color: '#fff',
            textTransform: 'uppercase',
            py: 0.25,
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
}

function getTimeLeft(deadline) {
  const diff = deadline - new Date();

  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((diff % (1000 * 60)) / 1000),
  };
}

const LATE_BIRD_DEADLINE = new Date('2026-10-05T00:00:00');

export default function LateBirdBanner() {
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(LATE_BIRD_DEADLINE));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft(LATE_BIRD_DEADLINE));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        mb: 3,
        width: '100%',
        boxSizing: 'border-box',
        px: { xs: 2, md: 4 },
        py: { xs: 2, md: 3 },
        bgcolor: '#FFE500',
        border: '1px solid #E6D000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: { xs: 2, md: 4 },
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ flex: 1, minWidth: { xs: 0, md: 280 } }}>
        <Typography
          sx={{
            display: 'inline-block',
            bgcolor: '#111',
            color: '#fff',
            px: 1.5,
            py: 0.5,
            mb: 1.5,
            fontSize: '0.75rem',
            fontWeight: 800,
            letterSpacing: 2,
            textTransform: 'uppercase',
          }}
        >
          Bis {moment(LATE_BIRD_DEADLINE).format('D. MMMM YYYY')}
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: '1.5rem', md: '1.8rem' },
            fontWeight: 800,
            color: '#111',
            lineHeight: 1.05,
          }}
        >
          Sichern Sie sich jetzt noch Ihr Ticket zum Vorteilspreis!
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          gap: 1,
          flexShrink: 0,
          justifyContent: { xs: 'center', md: 'flex-end' },
          width: { xs: '100%', md: 'auto' },
        }}
      >
        <CountdownUnit value={timeLeft.days} label="Tage" />
        <CountdownUnit value={timeLeft.hours} label="Std" />
        <CountdownUnit value={timeLeft.minutes} label="Min" />
        <CountdownUnit value={timeLeft.seconds} label="Sek" />
      </Box>
    </Box>
  );
}
